/** Slower poll after a failed read; stopping would freeze a transfer still in flight. */
export const ERROR_BACKOFF_MS = 30_000;
